import type { FaireProductEntity } from "../../entity_types/product";

export const p_6e7w2ra4zc: FaireProductEntity = {
  token: "p_6e7w2ra4zc",
  type: "product",
  name: "KIND People Hoodie - Vintage Charcoal Sweatshirt",
  brandToken: "b_92yk6t891p",
  brandName: "to: little arrows",
  imageUrl:
    "https://cdn.faire.com/fastly/d4564c6773798f310a86c84f5c5f31995fc1c9a017458b7629906acb7ef0ecf9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe88a2de84503be091afa11b05b9938887c0ea2761683d7293c815c39650b926.jpeg",
    "https://cdn.faire.com/fastly/a2996556042732613aa422c48fccf6c2a24e6fe1c81882b516d85df1353d7272.jpeg",
    "https://cdn.faire.com/fastly/eb6566ad422d583aef82fd4739cd1bc7c88d3b089c920cdc75ad24f4b69af1b8.jpeg",
    "https://cdn.faire.com/fastly/30b94718625dd5dd73a25150c03d61984f43e5794be0a9a814c1512c5149798b.jpeg",
    "https://cdn.faire.com/fastly/8c13a3b1743cf9c864a7b9b22967718b786ca436247f8786a51b6f9c5cb9d4a6.jpeg",
    "https://cdn.faire.com/fastly/3a8747514524fa6032d8b6b6c16baae461a70ce047690b57942fb1c780a67661.jpeg",
  ],
  priceDollars: 14.99,
  description:
    "\nIn today's world we could all use more kind people. We love this new vintage style charcoal hoodie! \n\nLong sleeve garment washed cotton-blend fleece hoodie in vintage charcoal grey. Fading and distressing through out. Graphic printed in multicolor at front and back. Kangaroo pocket at waist. Rib knit cuffs and hem. Tonal stitching.\n\nDetails:\n\n * Cotton/poly \n * Machine wash \n * Imported \nSize + Fit:\n\n * Relaxed fit \n * XS(4-5), S(6-7), M(8-9), L(10-12), XL(13-14) \n\n",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:04.155Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
